'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Predicate2 = require('../abstract/Predicate');

var _Predicate3 = _interopRequireDefault(_Predicate2);

var _operators = require('../operators');

var _descriptorValue = require('../util/descriptorValue');

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptorPredicate = function (_Predicate) {
    (0, _inherits3.default)(DescriptorPredicate, _Predicate);

    function DescriptorPredicate() {
        (0, _classCallCheck3.default)(this, DescriptorPredicate);
        return (0, _possibleConstructorReturn3.default)(this, (DescriptorPredicate.__proto__ || (0, _getPrototypeOf2.default)(DescriptorPredicate)).apply(this, arguments));
    }

    (0, _createClass3.default)(DescriptorPredicate, [{
        key: 'getDataType',
        value: function getDataType() {
            var dataType = this.descriptor.dataType;

            if (dataType.toLowerCase() === 'dataset') {
                return this.descriptor.dataset.dataType;
            }
            return dataType;
        }
    }, {
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            var value = (0, _operators.getOperatorQueryFragment)(this.operator, this.treatedValue, this.getDataType());
            if (value === null) {
                // if descriptor value is null, don't include it into the query
                return null;
            }
            return {
                'descriptors._arr': {
                    $elemMatch: {
                        id: this.descriptorId,
                        value: value
                    }
                }
            };
        }
    }, {
        key: 'descriptor',
        get: function get() {
            return this.data.descriptor;
        },
        set: function set(value) {
            this.data.descriptor = value;
        }
    }, {
        key: 'descriptorId',
        get: function get() {
            return this.descriptor && this.descriptor.id || -1;
        }
    }, {
        key: 'operator',
        get: function get() {
            return this.data.operator;
        },
        set: function set(value) {
            this.data.operator = value;
        }
    }, {
        key: 'name',
        get: function get() {
            return this.data.name;
        },
        set: function set(value) {
            this.data.name = value;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.data.value;
        },
        set: function set(value) {
            this.data.value = value;
        }
    }, {
        key: 'treatedValue',
        get: function get() {
            var value = this.data.value;
            var _descriptor = this.descriptor,
                dataType = _descriptor.dataType,
                dataset = _descriptor.dataset;


            return (0, _descriptorValue.treatValue)({ value: value, dataType: dataType, dataset: dataset });
        }
    }]);
    return DescriptorPredicate;
}(_Predicate3.default);

DescriptorPredicate.defaultData = {
    operator: null
};
DescriptorPredicate.displayName = 'Document Attribute';

_QueryNodeRegistry2.default.register(DescriptorPredicate);
exports.default = DescriptorPredicate;